import i18next from 'i18next';

const CalculationDescription = () => {
  const AccordionDescription: string[] = i18next.t('valuation.calculation.body', {
    returnObjects: true,
  });

  return `
    <div class="waykevaluation-content">
      ${AccordionDescription.map(
        (d, i) =>
          `<p class="waykevaluation-content__p${
            i === 0 ? ' waykevaluation-text waykevaluation-text--font-medium' : ''
          }">${d}</p>`
      ).join('')}
    </div>
  `;
};

export default CalculationDescription;
